"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledSpinner = _styledComponents.default.svg.withConfig({
  displayName: "Spinner__StyledSpinner",
  componentId: "sc-108434h-0"
})(["animation:rotate 1s linear infinite;width:", "px;height:", "px;& .path{stroke:#6175de;stroke-linecap:round;animation:dash 2s ease-in-out infinite;}@keyframes rotate{100%{transform:rotate(360deg);}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0;}50%{stroke-dasharray:90,150;stroke-dashoffset:-35;}100%{stroke-dasharray:90,150;stroke-dashoffset:-124;}}"], function (props) {
  return props.size ? props.size : 30;
}, function (props) {
  return props.size ? props.size : 30;
});

var Spinner = function Spinner(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/_react.default.createElement(StyledSpinner, {
    viewBox: "0 0 50 50",
    size: size
  }, /*#__PURE__*/_react.default.createElement("circle", {
    className: "path",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    strokeWidth: "4"
  }));
};

var _default = Spinner;
exports.default = _default;